import Panel from "./ExpansionPanel";
import PanelDetails from "./ExpansionPanelDetails";
import PanelSummary from "./ExpansionPanelSummary";

export const ExpansionPanel = Panel;
export const ExpansionPanelDetails = PanelDetails;
export const ExpansionPanelSummary = PanelSummary;
